<template>
  <div class="bar-percentage">
    <div
      class="bar-percentage__progress"
      :style="`width: ${percentage}%;`"
      :class="
        passed
          ? 'bar-percentage__progress--success'
          : 'bar-percentage__progress--fail'
      "
    ></div>
  </div>
</template>
<script>
export default {
  name: 'BarPercentage',
  props: {
    percentage: {
      type: Number,
      required: true,
    },
    passed: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.bar-percentage {
  position: relative;
  height: 8px;
  width: 80%;
  background: linear-gradient(
    112.2deg,
    rgba(187, 188, 199, 0.7) -46.39%,
    rgba(187, 188, 199, 0) 112.38%
  );
  border-radius: 10px;

  @include mobile {
    width: 106px;
  }
  &__progress {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    border-radius: 10px;
    &--success {
      background: linear-gradient(145.56deg, #00da99 20.53%, #70ffd4 79.76%);
    }
    &--fail {
      background: linear-gradient(180deg, #e52a2a 0%, #ff5e5e 100%);
    }
  }
}
</style>
